import React, { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, Collapse } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import c from 'classnames';

import SettingsMenu from './components/SettingsMenu';
import { matchRoute } from '../../utils/matchRoute';
import { menuSections, subMenuObjects } from '../../utils/menu';

import './_menuMobile.scss';

const MenuMobile = ({ open, toggleDrawer }) => {
  const { pathname } = useLocation();
  const { data: { is_group_admin } } = useSelector(s => s.account);
  const { data: { access_token } } = useSelector(s => s.getSendbirdToken);
  const { unreadMessagesCount } = useSelector(s => s.sendbirdUnreadMessages);
  const [expand, setExpand] = useState(subMenuObjects(is_group_admin));
  const stripeUrl = useSelector(s => s.stripeBilling?.data?.url || '');

  const handleClick = key => {
    setExpand({
      ...expand,
      [key]: !expand[key]
    });
  };

  const filterItems = items => items.filter(item => !item.unreadBadge || Boolean(access_token));

  const renderMenuItems = items => (
    filterItems(items).map(element => {
      let active = element.path ? matchRoute(pathname, element.path) : false;

      return element.path ? (
        <Link
          to={element.path}
          className={c('menu-list-item', { 'active': active })}
          key={element.id}
          onClick={e => {
            toggleDrawer()(e);
          }}
        >
          {active && <div className="active-line" />}
          <ListItemIcon>{element.icon}</ListItemIcon>
          <ListItemText className="text" primary={element.title} />
          {element.unreadBadge && Boolean(unreadMessagesCount) && <div className="unread-dot" />}
        </Link>
      ) : (
        element.title !== 'Payments' ? (
          <Fragment key={element.id} >
            <ListItem button className="menu-list-item" onClick={() => handleClick(element.id)}>
              <ListItemIcon>{element.icon}</ListItemIcon>
              <ListItemText className="text" primary={element.title} />
              {
                element.more
                  ? expand[element.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />
                  : null
              }
            </ListItem>
            {
              element.more && expand[element.id] && (
                <Collapse in={expand} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {
                      element.more.map(el => {
                        active = matchRoute(pathname, el.path);

                        return (
                          (
                            <Link
                              to={el.path}
                              className={c('menu-list-item sub', { 'active': active })}
                              key={el.id}
                              onClick={e => {
                                toggleDrawer()(e);
                              }}
                            >
                              {active && <div className="active-line" />}
                              <ListItemIcon>{el.icon}</ListItemIcon>
                              <ListItemText className="text" primary={el.title} />
                            </Link>
                          )
                        );
                      })
                    }
                  </List>
                </Collapse>
              )
            }
          </Fragment>
        ) : (
          <a href={stripeUrl} className={c('menu-list-item', { 'active': active })} key={element.id} rel="noopener noreferrer">
            <ListItem button>
              <ListItemIcon>{element.icon}</ListItemIcon>
              <ListItemText className="text" primary={element.title} />
            </ListItem>
          </a>
        )
      );
    })
  );

  const sideList = () => (
    <List className="menu-list">
      <div>
        <Typography className="menu-list-section">Menu</Typography>
        {menuSections(is_group_admin).map((section, i) => (
          <div key={i}>
            {section.title && <Typography className="menu-list-section small">{section.title}</Typography>}
            {renderMenuItems(section.items)}
          </div>
        ))}
      </div>
      <SettingsMenu isAdmin={is_group_admin} />
    </List>
  );

  return (
    <div className="mobile-menu">
      <Drawer classes={{ paper: 'drawer-paper' }} className="mobile-menu-drawer" open={open} onClose={toggleDrawer()}>
        {sideList()}
      </Drawer>
    </div>
  );
};

MenuMobile.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired
};

export default MenuMobile;